import styles from './styles.module.scss'

export default function Input(props) {
  return <input type="text" {...props} className={`${styles.input} w-full h-[46px] px-[22px] rounded-[4px] ${props.className} ${props.disabled ? 'opacity-50' : ''} ${props.error ? '!border-[#F13C3C]' : ''}`} />
}
